import React from "react";
import "./EngineeringInsurance.scss";
import engine from "../../../assets/Services/engine.png";
import engineeringImg from "../../../assets/Services/engineering-img.png";

const EngineeringInsurance = () => {
  return (
    <>
      <div className="engineering_service">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${engine})` }}
          ></div>

          <div className="heading_box">Engineering Insurance</div>
          <div className="service_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left mb-4 mb-lg-0">
                    <h4>Engineering INSURANCES</h4>
                    <ul>
                      <li>Machinery Insurance ( Machinery Breakdown)</li>
                      <li>Deterioration of Stocks (DOS)</li>
                      <li>Boiler and Pressure Vessel (BPV)</li>
                      <li>Electronic Equipment Insurance (EEI)</li>
                      <li>Erection All Risks (EAR)</li>
                      <li>Contractor’s All Risk (CAR)</li>
                      <li>Work Plant (WP)</li>
                      <li>Oil & Gas Well Drilling Equipment Package (OGD)</li>
                      <li>Contractors Plant & Machinery (CPM)</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 my-auto">
                  <img src={engineeringImg} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EngineeringInsurance;
